import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { DataGrid, GridLinkOperator, GridToolbarQuickFilter } from '@mui/x-data-grid';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import SearchData from '../../components/SearchData';
import api from "../../../../components/services/api";
import { useHistory, useParams } from 'react-router';
import Swal from 'sweetalert2';
import mime from 'mime';
import { saveAs } from "file-saver";

function QuickSearchToolbar() {
    const { id } = useParams()
    const [loading, setLoading] = useState(false)
    return (
        <Box
            sx={{
                p: 1,
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between'
            }}
        >
            <div style={{ display: 'flex' }}>
                <Button
                    variant="outlined"
                    style={{ color: "#84BD5A", borderColor: "#84BD5A" }}

                    onClick={async () => {
                        setLoading(true)
                        await api.get(`api/report/saleorder/containerlist/${id}`, {
                            responseType: "blob",
                            timeout: 30000
                        })
                            .then((blobFile) => {
                                const blobFileRes = new File([blobFile?.data], "test.xlsx", {
                                    type: mime.getType(".xlsx"),

                                });

                                // window.open(
                                //   URL.createObjectURL(blobFileRes, "test.csv"),
                                //   "_blank"
                                // );
                                saveAs(blobFileRes, "Report.xlsx");
                                setLoading(false)
                            });

                    }}
                >
                    <span className="material-icons-outlined">description</span>
                    {loading ? <CircularProgress size={22} /> : <Typography sx={{ color: "#8E8C8C" }}>Export</Typography>}
                </Button>

            </div>

            <GridToolbarQuickFilter
                quickFilterParser={(searchInput) =>
                    searchInput
                        .split(',')
                        .map((value) => value.trim())
                        .filter((value) => value !== '')
                }
            />
        </Box>
    );
}
export default function Container() {
    const { id } = useParams()
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false)
    const [loadingPDF, setLoadingPDF] = useState(false)
    const [loadingCRPDF, setLoadingCRPDF] = useState(false)
    const [remarkType, setremarkType] = useState("");
    const [diremark, setDiremark] = useState(false);
    const [remarklog, setremarkLog] = useState("");

    // const [uniqueContainerSizeTotal, setUniqueContainerSizeTotal] = useState([]);
    // const [uniqueContainerSizeHeader, setUniqueContainerSizeHeader] = useState([]);
    const [dataContainerList, setDataContainerList] = useState([]);
    const [dataFilterContainerList, setDataFilterContainerList] = useState([]);
    const handleCloseremark = () => {
        setDiremark(false)
        setremarkLog('')
        setremarkType('')
    }
    const getContainerList_Data = async (res) => {
        try {
            const obj_id = {
                id: id,
            };
            const data = await api.get(`api/saleorder/detail/container/${id}`);
            setDataContainerList(data.data);
            setDataFilterContainerList(data.data.map((x, i) => ({
                ...x,
                no: i + 1
            })));
            // console.log(data);

            // const dataReduceSize = data.data.reduce(
            //     (prev, cur) => ({
            //         ...prev,
            //         [cur.Size]: (prev[cur.Size] || 0) + 1,
            //     }),

            //     {}
            // );

            // setUniqueContainerSizeTotal([dataReduceSize]);

            // const newSizeArray = [];
            // data.data.forEach((element) => {
            //     // console.log(element.Size);
            //     newSizeArray.push(element.Size);
            // });

            // setUniqueContainerSizeHeader([...new Set(newSizeArray)]);
        } catch (e) {
            // setCustomer_data(payment_data);
            console.log(e);
        }
    };
    useEffect(() => {
        getContainerList_Data()
    }, [])
    const columnsContainerList = [
        // {
        //   field: "Status",
        //   headerName: "STATUS",
        //   width: 150,
        //   valueFormatter: ({ value }) => (value == 1 ? "INSTOCK" : "OUTSTOCK"),
        // },
        {
            field: "no", headerName: "No", width: 100, sortable: false,
        },
        {
            field: "ContainerNo", headerName: "Container Number", width: 200, renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='Container Number'
                            // error={Boolean(touched.lastname)}
                            disabled={params?.row?.ContainerId?.toString().includes('-') ? false : true}
                            variant="outlined"
                            value={params?.row?.ContainerNo}
                            onChange={e => {
                                const select = dataFilterContainerList?.map((y) => {

                                    y.ContainerNo = y?.ContainerId === params?.row?.ContainerId ? e.target.value : y?.ContainerNo
                                    return y
                                })

                                setDataFilterContainerList([...select])
                            }}
                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        />
                    </>
                )
            }
        },
        {
            field: "SealShipper", headerName: "Seal Shipper", width: 180, renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='Seal Shipper'
                            // error={Boolean(touched.lastname)}
                            disabled={params?.row?.ContainerId?.toString().includes('-') ? false : true}
                            variant="outlined"
                            value={params?.row?.SealShipper}
                            onChange={e => {
                                const select = dataFilterContainerList?.map((y) => {

                                    y.SealShipper = y?.ContainerId === params?.row?.ContainerId ? e.target.value : y?.SealShipper
                                    return y
                                })

                                setDataFilterContainerList([...select])
                            }}
                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        />
                    </>
                )
            }
        },
        {
            field: "SealShipper2", headerName: "Seal Carrier 1", width: 180, renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='Seal Carrier 1'
                            // error={Boolean(touched.lastname)}
                            variant="outlined"
                            disabled={params?.row?.ContainerId?.toString().includes('-') ? false : true}
                            value={params?.row?.SealShipper2}
                            onChange={e => {
                                const select = dataFilterContainerList?.map((y) => {

                                    y.SealShipper2 = y?.ContainerId === params?.row?.ContainerId ? e.target.value : y?.SealShipper2
                                    return y
                                })

                                setDataFilterContainerList([...select])
                            }}
                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        />
                    </>
                )
            }
        },
        {
            field: "SealCarrier", headerName: "Seal Carrier 2", width: 180, renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='Seal Carrier 2'
                            // error={Boolean(touched.lastname)}
                            disabled={params?.row?.ContainerId?.toString().includes('-') ? false : true}
                            variant="outlined"
                            value={params?.row?.SealCarrier}
                            onChange={e => {
                                const select = dataFilterContainerList?.map((y) => {

                                    y.SealCarrier = y?.ContainerId === params?.row?.ContainerId ? e.target.value : y?.SealCarrier
                                    return y
                                })

                                setDataFilterContainerList([...select])
                            }}
                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        />
                    </>
                )
            }
        },
        {
            field: "ContainerTareWeight", headerName: "Tare Weight", width: 150, renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='Container Tare Weight'
                            // error={Boolean(touched.lastname)}
                            disabled={params?.row?.ContainerId?.toString().includes('-') ? false : true}
                            variant="outlined"
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            value={params?.row?.ContainerTareWeight}
                            onChange={e => {
                                const select = dataFilterContainerList?.map((y) => {

                                    y.ContainerTareWeight = y?.ContainerId === params?.row?.ContainerId ? e.target.value : y?.ContainerTareWeight
                                    y.VGMWeight = y?.ContainerId === params?.row?.ContainerId ? +e.target.value + +params?.row?.CargoWeight : y?.VGMWeight

                                    return y
                                })

                                setDataFilterContainerList([...select])
                            }}
                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        />
                    </>
                )
            }
        },
        {
            field: "CargoWeight", headerName: "Cargo Weight", width: 150, renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='Cargo Weight'
                            // error={Boolean(touched.lastname)}
                            disabled={params?.row?.ContainerId?.toString().includes('-') ? false : true}
                            variant="outlined"
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            value={params?.row?.CargoWeight}
                            onChange={e => {
                                const select = dataFilterContainerList?.map((y) => {

                                    y.CargoWeight = y?.ContainerId === params?.row?.ContainerId ? e.target.value : y?.CargoWeight
                                    y.VGMWeight = y?.ContainerId === params?.row?.ContainerId ? +e.target.value + +params?.row?.ContainerTareWeight : y?.VGMWeight

                                    return y
                                })

                                setDataFilterContainerList([...select])
                            }}
                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        />
                    </>
                )
            }
        },
        {
            field: "VGMWeight", headerName: "VGM Weight", width: 150, renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='VGM Weight'
                            disabled
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            // error={Boolean(touched.lastname)}
                            variant="outlined"
                            value={params?.row?.VGMWeight}

                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        />
                    </>
                )
            }
        },
        {
            field: "GoodControlNo", headerName: "Good Control No.", width: 150, renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='GoodControlNo'
                            disabled={params?.row?.ContainerId?.toString().includes('-') ? false : true}

                            variant="outlined"
                            value={params?.row?.GoodControlNo || ''}
                            onChange={e => {
                                const select = dataFilterContainerList?.map((y) => {

                                    y.GoodControlNo = y?.ContainerId === params?.row?.ContainerId ? e.target.value : y?.GoodControlNo
                                    return y
                                })

                                setDataFilterContainerList([...select])
                            }}
                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        /></>
                )
            }
        },
        {
            field: "VoyIn", headerName: "Voy In", width: 150
        },
        {
            field: "WagonEmpty", headerName: "Wagon Empty", width: 150,
        },
        {
            field: "VoyOut", headerName: "Voy Out", width: 150,
        },
        {
            field: "WagonLaden", headerName: "Wagon Laden", width: 150,
        },

        {
            field: "Remark", headerName: "Remark", width: 300, renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='Remark'
                            disabled={params?.row?.ContainerId?.toString().includes('-') ? false : true}

                            // error={Boolean(touched.lastname)}
                            variant="outlined"
                            value={params?.row?.Remark}
                            onChange={e => {
                                const select = dataFilterContainerList?.map((y) => {

                                    y.Remark = y?.ContainerId === params?.row?.ContainerId ? e.target.value : y?.Remark
                                    return y
                                })

                                setDataFilterContainerList([...select])
                            }}
                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        />
                    </>
                )
            }
        },
    ];
    return (
        <>
            <Grid
                style={{
                    marginTop: "10px",
                    display: "flex",
                    flexDirection: "row",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                    }}
                >
                    {/* {console.log(uniqueContainerSizeTotal)} */}
                    {/* {uniqueContainerSizeTotal.length > 0
                        ? uniqueContainerSizeHeader.map((res, index) => {
                            return (
                                <Box
                                    style={{
                                        backgroundColor: "#30318D",
                                        color: "white",
                                        borderRadius: "5px",
                                        whiteSpace: "nowrap",
                                        margin: "5px",
                                        padding: "5px",
                                    }}
                                >
                                    Total Size {uniqueContainerSizeHeader[index]} '
                                    <text
                                        style={{
                                            backgroundColor: "white",
                                            color: "black",
                                            borderRadius: "5px",
                                            margin: "5px",
                                            padding: "5px",
                                        }}
                                    >
                                        {
                                            uniqueContainerSizeTotal.map((res, i) => {
                                                // console.log(
                                                //   res[uniqueContainerSizeHeader[index]]
                                                // );
                                                return res[uniqueContainerSizeHeader[index]];
                                            })
                                            // res[uniqueContainerSizeTotal[index]]
                                        }
                                    </text>
                                </Box>
                            );
                        })
                        : null} */}
                </Box>
                {/* <SearchData
                    name={dataContainerList}
                    onsetData={setDataFilterContainerList}
                /> */}
            </Grid>
            <Box
                sx={{
                    height: 700,
                    width: "100%",
                    marginTop: "10px",
                    "& .Active": {
                        color: "#28A745",
                    },
                    "& .Inactive": {
                        color: "#F53C56",
                    },
                }}
            >
                <DataGrid
                    getRowId={(r) => r.ContainerId}
                    rows={dataFilterContainerList}
                    columns={columnsContainerList}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    hideFooterSelectedRowCount
                    disableColumnFilter
                    disableColumnMenu
                    getCellClassName={(params) => {
                        if (params.field === "Status") {
                            return params.value == 1 ? "Active" : "Inactive";
                        }
                    }}
                    initialState={{
                        filter: {
                            filterModel: {
                                items: [],
                                quickFilterLogicOperator: GridLinkOperator.Or,
                            },
                        },
                    }}
                    components={{ Toolbar: QuickSearchToolbar }}
                />
            </Box>
            <div style={{ display: "flex", marginTop: 10 }}>
                <Button
                    type="button"
                    variant="outlined"
                    style={{
                        color: "#80c340",
                        borderColor: "#80c340",
                        marginRight: "10px",
                    }}
                    onClick={history.goBack}
                >
                    back
                </Button>
                <Button
                    // type="submit"
                    variant="contained"
                    style={{
                        background: "#80c340",
                        borderColor: "#80c340",
                        marginRight: "10px",
                    }}
                    onClick={() => {
                        setDiremark(true)
                    }}

                    disabled={isLoading}
                >
                    {isLoading && <CircularProgress size={22} />}
                    {!isLoading && "SAVE"}
                </Button>
                <Button
                    variant="outlined"
                    style={{ color: "#84BD5A", borderColor: "#84BD5A", marginLeft: "5px", width: "250px" }}

                    onClick={async () => {
                        setLoadingPDF(true)
                        await api.get(`api/report/saleorder-containerlist/download/pdf?saleorderId=${id}`, {
                            responseType: "blob",
                            timeout: 30000
                        })
                            .then((blobFile) => {
                                const blobFileRes = new File([blobFile?.data], "test.pdf", {
                                    type: mime.getType(".pdf"),

                                });

                                // window.open(
                                //   URL.createObjectURL(blobFileRes, "test.csv"),
                                //   "_blank"
                                // );
                                saveAs(blobFileRes, "Report-saleorder-container-list.pdf");
                                setLoadingPDF(false)
                            });

                    }}
                >
                    {loadingPDF ? <CircularProgress size={22} /> : <Typography sx={{ color: "#8E8C8C" }}>report-container-list</Typography>}
                </Button>
                <Button
                    variant="outlined"
                    style={{ color: "#84BD5A", borderColor: "#84BD5A", marginLeft: "5px", width: "250px" }}

                    onClick={async () => {
                        setLoadingCRPDF(true)
                        await api.get(`api/report/cargo-receipt/download/pdf?saleorderId=${id}`, {
                            responseType: "blob",
                            timeout: 30000
                        })
                            .then((blobFile) => {
                                const blobFileRes = new File([blobFile?.data], "test.pdf", {
                                    type: mime.getType(".pdf"),

                                });

                                // window.open(
                                //   URL.createObjectURL(blobFileRes, "test.csv"),
                                //   "_blank"
                                // );
                                saveAs(blobFileRes, "Report-cargo-receipt.pdf");
                                setLoadingCRPDF(false)
                            });

                    }}
                >
                    {loadingCRPDF ? <CircularProgress size={22} /> : <Typography sx={{ color: "#8E8C8C" }}>report-cargo-receipt</Typography>}
                </Button>
                <Dialog fullWidth="sm" open={diremark}>
                    <DialogTitle>Remark</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    autoFocus
                                    style={{marginTop:'5px'}}
                                    name="RemarkLog"
                                    label="Remark"
                                    fullWidth
                                    color="success"
                                    variant="outlined"
                                    onChange={(r) => setremarkLog(r.target.value)}
                                /></Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Remark Option</InputLabel>
                                    <Select
                                        name="RemarkType"
                                        label="Remark Type"
                                        value={remarkType}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => setremarkType(e.target.value)}
                                        MenuProps={{
                                            style: {
                                                maxHeight: 400,
                                            },
                                        }}
                                    // disabled={values.inco_terms ? true : false}
                                    >

                                        {[
                                           'Container No.',
                                           'Seal Carrier No.'
                                       
                                        ].map((option, index) => {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    value={option}
                                                >
                                                    {option}
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>

                        </Grid>
                        <DialogActions
                            sx={{
                                marginTop: "24px",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <form onSubmit={() => setDiremark(false)}>

                                <Button
                                    type="button"
                                    variant="outlined"
                                    style={{
                                        color: "#80c340",
                                        borderColor: "#80c340",
                                        marginRight: "10px",
                                    }}
                                    onClick={handleCloseremark}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    onClick={() => {
                                        const updateContainer = async () => {
                                            setIsLoading(true)
                                            const res = await api.post(`api/saleorder/update/container`, {
                                                SaleOrderId: id,
                                                ContainerList: dataFilterContainerList,
                                                RemarkLogStatus: remarklog,
                                                RemarkType: remarkType
                                            })
                                            if (res.meta.status) {
                                                setDiremark(false)
                                                Swal.fire({
                                                    title: `${res.meta.message}`,
                                                    icon: 'success',
                                                    confirmButtonColor: '#3085d6',
                                                    confirmButtonText: 'OK',
                                                    allowOutsideClick: false
                                                }).then((result) => {
                                                    if (result.isConfirmed) {
                                                        getContainerList_Data()
                                                        setIsLoading(false)
                                                    }
                                                })
                                            }
                                        }
                                        updateContainer()
                                    }}
                                    style={{
                                        background: remarklog ? "#80c340" : 'gray',
                                        borderColor: "#80c340",
                                        marginRight: "10px",
                                        color: "#FFF",
                                    }}
                                    disabled={isLoading || !remarklog ? true : false}
                                >
                                    {isLoading && <CircularProgress size={22} />}
                                    {!isLoading && "Submit"}
                                </Button>
                            </form>
                        </DialogActions>
                    </DialogContent>
                </Dialog>
            </div>
        </>
    )
}

